let mock = [{
    id: 1,
    name: "The Alliance",
    price: "$18.99",
    author: "Gerald Lund",
    genre: "Dystopian",
    image: 'allianceCover.jpg'
  },
  {
    id: 2,
    name: "Angel on the Square",
    price: "$9.99",
    author: "Gloria Whelan",
    genre: "Historical Fiction",
    image: 'angelOnTheSquareCover.jpeg'
  },
  {
    id: 3,
    name: "Ash and Bramble",
    price: "$14.95",
    author: "Sarah Prineas",
    genre: "Fantasy",
    image: 'ashAndBrambleCover.jpeg'
  },
  {
    id: 4,
    name: "Binti",
    price: "$9.49",
    author: "Nnedi Okorafor",
    genre: "Science Fiction",
    image: 'bintiCover.jpg'
  },
  {
    id: 5,
    name: "The Book Thief",
    price: "$6.99",
    author: "Markus Zusak",
    image: 'bookThiefCover1.jpg'

  },
  {
    id: 6,
    name: "Cinder",
    price: "$7.99",
    author: "Marissa Meyer",
    genre: "Science Fiction",
    image: 'cinderCover.jpeg'
  },
  {
    id: 7,
    name: "The Cruel Prince",
    price: "$9.46",
    author: "Holly Black",
    genre: "Fantasy",
    image: 'cruelPrinceCover.jpg'
  },
  {
    id: 8,
    name: "Dangerous",
    price: "$9.99",
    author: "Shannon Hale",
    genre: "Science Fiction",
    image: 'dangerousCover.jpeg'
  },
  {
    id: 9,
    name: "Dark One",
    price: "$17.99",
    author: "Brandon Sanderson",
    genre: "Fantasy",
    image: 'darkOneCover.jpeg'

  },
  {
    id: 10,
    name: "Dragon Slippers",
    price: "$8.49",
    author: "Jessica Day George",
    genre: "Fantasy",
    image: 'dragonSlippersCover.jpeg'
  },
  {
    id: 11,
    name: "Ever the Hunted",
    price: "$8.59",
    author: "Erin Summerill",
    genre: "Fantasy",
    image: 'everTheHuntedCover.jpg'
  },
  {
    id: 12,
    name: "Heart of a Samurai",
    price: "$7.29",
    author: "Margi Preus",
    genre: "Historical Fiction",
    image: 'heartOfASamuraiCover.jpeg'
  },
  {
    id: 13,
    name: "Illuminae",
    price: "$9.96",
    author: "Amie Kaufman and Jay Kristoff",
    genre: "Science Fiction",
    image: 'illuminaeCover.jpg'
  },
  {
    id: 14,
    name: "Legend",
    price: "$7.68",
    author: "Marie Lu",
    genre: "Dystopian",
    image: 'legendCover.jpeg'
  },
  {
    id: 15,
    name: "Out of my Mind",
    price: "$7.49",
    author: "Sharon M. Draper",
    genre: "Contemporary",
    image: 'outOfMyMindCover.jpeg'
  },
  {
    id: 16,
    name: "Peter and the Starcatchers",
    price: "$9.19",
    author: "Dave Barry and Ridley Pearson",
    genre: "Fantasy",
    image: 'peterAndTheStarcatchers1.jpg'
  },
  {
    id: 17,
    name: "Pillage",
    price: "$15.32",
    author: "Obert Skye",
    genre: "Fantasy",
    image: 'pillageCover.jpeg'
  },
  {
    id: 18,
    name: "The Princess Bride",
    price: "$17.99",
    author: "William Goldman",
    genre: "Fantasy",
    image: 'princessBrideCover.jpeg'
  },
  {
    id: 19,
    name: "Runaway",
    price: "$9.99",
    author: "Wendelin van Draanen",
    genre: "Contemporary",
    image: 'runawayCover.jpeg'
  },
  {
    id: 20,
    name: "Scythe",
    price: "$18.89",
    author: "Neal Shusterman",
    genre: "Science Fiction",
    image: 'scytheCover.jpeg'
  },
  {
    id: 21,
    name: "Shadow and Bone",
    price: "$3.16",
    author: "Leigh Bardugo",
    genre: "Fantasy",
    image: 'shadowAndBoneCover.jpeg'
  },
  {
    id: 22,
    name: "A Single Shard",
    price: "$8.99",
    author: "Linda Sue Park",
    genre: "Historical Fiction",
    image: 'singleShardCover.jpeg'
  },
  {
    id: 23,
    name: "The Way of Kings",
    price: "$22.40",
    author: "Brandon Sanderson",
    genre: "Fantasy",
    image: 'wayOfKingsCover.jpeg'
  },
  {
    id: 24,
    name: "We are Legion We are Bob",
    price: "$12.99",
    author: "Dennis E. Taylor",
    genre: "Science Fiction",
    image: 'weAreLegionWeAreBobCover.jpg'
  },
  {
    id: 25,
    name: "The Westing Game",
    price: "$5.49",
    author: "Ellen Raskin",
    genre: "Mystery",
    image: 'westingGameCover.jpeg'
  },
  {
    id: 26,
    name: "Where the Mountain Meets the Moon",
    price: "$9.99",
    author: "Grace Lin",
    genre: "Fantasy",
    image: 'whereTheMountainMeetsTheMoon1.jpg'
  },
  {
    id: 27,
    name: "A Wrinkle in Time",
    price: "$6.99",
    author: "Madeleine L'Engle",
    genre: "Science Fiction",
    image: 'wrinkleInTimeCover.jpeg'

  },
  {
    id: 28,
    name: "Zeroes",
    price: "$16.37",
    author: "Scott Westerfeld",
    genre: "Science Fiction",
    image: 'zeroesCover.jpeg'
  }
]

export default mock;
